import React from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import Dialog from '@smart-tv/components/dialog';

import useEventListener from '@smart-tv/hooks/use-event-listener';
import useGDPR from '@smart-tv/hooks/use-gdpr';

import GDPRDialogContent from './gdpr-dialog-content';
import closeTvApp from '@smart-tv/utils/closeTvApp';
import { isBackKey } from '@smart-tv/utils/remoteKeys';
import { IS_WEBOS } from '@smart-tv/utils/is-webos';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const GDPRDialog: React.FC<Props> = (props: Props) => {
  const { onClose, open } = props;

  const { firstTimeLaunch } = useGDPR();

  const handleKeyPress = React.useCallback(
    (event: KeyboardEvent) => {
      if (firstTimeLaunch && (window.tizen || IS_WEBOS) && isBackKey(event)) {
        closeTvApp();
      } else if (isBackKey(event)) {
        onClose();
      }
    },
    [firstTimeLaunch, onClose]
  );

  useEventListener('keydown', (event: KeyboardEvent) => handleKeyPress(event));

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={() => onClose}
      disableEscapeKeyDown={firstTimeLaunch}
      data-testid={testIds.gdpr.dialog}
      showCloseButton={false}
    >
      <GDPRDialogContent open={open} />
    </Dialog>
  );
};

export default React.memo(GDPRDialog);
